import { AntragMetaData } from '../model';
import { Guid } from '@ebeihilfe/core';

export class PartiallyTypedNewAntrag {
  public antragId: Guid;
  public concurrency: Date;
  public metadata: AntragMetaData;

  constructor(antragId: Guid, concurrency: Date, metadata: AntragMetaData) {
    this.antragId = antragId;
    this.concurrency = concurrency;
    this.metadata = metadata;
  }
}
